import React from "react";
import MuiDialogContent, { DialogContentProps } from "@mui/material/DialogContent";
import { styled } from "@mui/material/styles";
import { css } from "@emotion/react";

type Props = DialogContentProps;

const DialogContent: React.FC<Props> = React.forwardRef((props, ref) => {
  return <StyledMuiDialogContent ref={ref} {...props} />;
});

const StyledMuiDialogContent = styled(MuiDialogContent)(
  ({ theme }) => css`
    font-size: 14px;
    line-height: 150%;
    color: ${theme.palette.objective.dark.fiordland};
    padding: 24px;

    ${theme.breakpoints.up("sm")} {
      min-width: 600px;
    }
  `
);

export default DialogContent;
